var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommaUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 32,
    viewBox: "0 0 55 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4375 0.625C53.6458 4 52.8333 7.54167 52 11.25C51.2083 14.9583 50.4792 18.6042 49.8125 22.1875C49.1458 25.7292 48.5833 28.9792 48.125 31.9375H30.625L29.75 30.5625C30.5 27.5208 31.4583 24.2917 32.625 20.875C33.8333 17.4167 35.125 13.9583 36.5 10.5C37.9167 7 39.3333 3.70833 40.75 0.625H54.4375ZM25.25 0.625C24.4583 4 23.6458 7.54167 22.8125 11.25C22.0208 14.9583 21.2917 18.6042 20.625 22.1875C19.9583 25.7292 19.3958 28.9792 18.9375 31.9375H1.4375L0.5625 30.5625C1.3125 27.5208 2.27083 24.2917 3.4375 20.875C4.64583 17.4167 5.9375 13.9583 7.3125 10.5C8.72917 7 10.1458 3.70833 11.5625 0.625H25.25Z",
    fill: "#83BA01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommaUp);
export default __webpack_public_path__ + "static/media/comma_up.651bd284f33e2a2ff9363229476f537f.svg";
export { ForwardRef as ReactComponent };